















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ErrorDisplay from '@/components/ErrorDisplay.vue'
import _ from 'lodash'
import { ConcourInterface } from '@/types/Concour'
import { BanqueInterface } from '@/types/Banque'

@Component({
    computed: {
        // Liste des banques
        liste_banques(): BanqueInterface[] {
            return _.orderBy(this.$store.getters['banque/banques'], 'name', 'asc')
        },
        // Liste des concours en fonction de la banque sélectionnée
        liste_concours(): ConcourInterface[] {
            return _.orderBy(
                this.$store.getters['concour/concours'].filter((concour: any) => {
                    return concour.banque_id === this.$data.select_banque
                }),
                'name',
                'asc'
            )
        }
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        ErrorDisplay
    }
})
export default class Comparaisons extends Vue {
    @Prop() showPopup?: boolean

    edit_groupe = false
    select_banque = 0
    select_concour = 0

    new_groupe: {libelle: string; concours: Array<{banque: BanqueInterface; concour: ConcourInterface}>} = {
        libelle: '',
        concours: []
    }

    /**
     * resetGroupe
     * @description Réinitialise le formulaire d'ajout de groupe de comparaisons
     * @return {void}
     */
    @Watch('edit_groupe')
    resetGroupe(): void {
        if (!this.edit_groupe) {
            this.select_banque = 0
            this.select_concour = 0

            this.new_groupe = {
                libelle: '',
                concours: []
            }
        }
    }

    /**
     * resetSelectConcour
     * @description Réinitialise la sélection d'un concours
     * @return {void}
     */
    @Watch('select_banque')
    resetSelectConcour(): void {
        this.select_concour = 0
    }

    /**
     * alreadyInList
     * @description Vérifie si un concours est déjà dans la liste
     * @param {number} concour_id - Id du concours à vérifier
     * @return {boolean}
     */
    alreadyInList(concour_id: number = this.select_concour): boolean {
        return !!this.new_groupe.concours.find((row: any) => row.concour.id === concour_id)
    }

    /**
     * addConcour
     * @description Ajoute un concours à la liste des concours à comparer
     * @return {void}
     */
    addConcour(): void {
        const select = document.getElementById('select-banque') as HTMLSelectElement
        select.setCustomValidity('')
        select.reportValidity()

        if (this.select_banque && this.select_concour && !this.alreadyInList()) {
            this.new_groupe.concours.push({
                banque: this.$store.getters['banque/banques']
                    .find((banque: any): boolean => banque.id === this.select_banque),
                concour: this.$store.getters['concour/concours']
                    .find((concour: any): boolean => concour.id === this.select_concour)
            })
        }
    }

    /**
     * removeConcour
     * @description Supprime un concours de la liste des concours à comparer
     * @param {number} concour_id - Id du concours à supprimer
     * @return {void}
     */
    removeConcour(concour_id: number): void {
        this.new_groupe.concours = this.new_groupe.concours.filter((row: any) => row.concour.id !== concour_id)
    }

    // Edition d'un groupe
    update_groupe(groupe_id: number) {
        console.log("recupere l'objet du groupe", groupe_id)
    }

    // Supprime un groupe de comparaisons
    delete_groupe(groupe_id: number) {
        console.log('Supprimer un groupe', groupe_id)
    }

    /**
     * save
     * @description Enregistre le groupe de comparaisons
     * @return {void}
     */
    save(): void {
        if (this.new_groupe.concours.length === 0) {
            const select = document.getElementById('select-banque') as HTMLSelectElement
            select.setCustomValidity('Veuillez ajouter au moins un concours à comparer.')
            select.reportValidity()
            return
        }
        console.log(this.new_groupe)
    }

    /**
     * cancel
     * @description Ferme la popup
     * @return {void}
     */
    cancel(): void {
        this.$emit('cancel')
    }

    /**
     * mounted
     * @description Chargement des banques et des concours
     * @return {Promise<void>}
     */
    async mounted(): Promise<void> {
        if (!this.$store.getters['banque/banques']) {
            await this.$store.dispatch('banque/getBanques', { perPage: 0 })
        }

        if (!this.$store.getters['concour/concours']) {
            await this.$store.dispatch('concour/getConcours', { perPage: 0 })
        }
    }
}
